import VehicleCfgs from 'vehicle-cfgs'
import GenericConfigItem from './GenericConfigItem.vue'
import ANConfigItem from './ANConfigItem.vue'
import DGConfigItem from './DGConfigItem.vue'
import UsoDaSerialConfigItem from './UsoDaSerialConfigItem.vue'

// Até agora as configs que vamos puxar do VehicleCfgs
// são todas Number ou LOV (as strings são apenas WifiSSID/Pass
// e anXLabel/anXScale, que serão componentes específicos)
function getConfigs(codes) {
  return codes.map((code) => {
    const configDef = VehicleCfgs.get(code)
    return {
      ...configDef,
      vueComponent: GenericConfigItem
    }
  })
}

// O UsoDaSerial é "quase" um GenericConfigItem,
// mas tem uma mensagem extra, então é outro cpte.
let usoDaSerialOrig = VehicleCfgs.get('uso-da-serial')
let usoDaSerial = {
  ...usoDaSerialOrig,
  vueComponent: UsoDaSerialConfigItem
}

// Os grupos serão montados de acordo com a estrutura manual abaixo
export default [
  {
    groupName: 'Sinais Analógicos',
    configs: [
      { anNumber: 1, vueComponent: ANConfigItem },
      { anNumber: 2, vueComponent: ANConfigItem },
      { anNumber: 3, vueComponent: ANConfigItem },
      { anNumber: 4, vueComponent: ANConfigItem }
    ]
  },
  {
    groupName: 'Sinais Digitais',
    configs: [
      { dgNumber: 1, vueComponent: DGConfigItem },
      { dgNumber: 2, vueComponent: DGConfigItem },
      { dgNumber: 3, vueComponent: DGConfigItem }
    ]
  },
  {
    groupName: 'Misc',
    configs: [
      usoDaSerial,
      ...getConfigs([
        // 'uso-da-serial',
        'accelerometerThreshold',
        // 'trecho-abre-apenas-com-rpm',
        'quebra-de-trecho-max-trip-duration',
        'quebra-de-trecho-tolerance',
        'bloqueio-com-timeout',
        'poly-change-warning',
        'pausa-do-gsm-durante-o-dia-em-min',
        'pausa-do-gsm-durante-a-noite-em-min',
        'limite-bytes-por-pacote',
        'mantem-motorista-logado',
        // 'limite-delta-v',
        'use-sqw-sync',
        'use-verbose',
        'use-rtcstack',
        'bat-limit'
      ])
    ]
  },
  {
    groupName: 'GPS',
    configs: getConfigs([
      'validacao-gps-metodo',
      'validacao-gps-limite',
      'gps-reset-minutes',
      'gps-write-distance',
      'gps-write-time'
    ])
  },
  {
    groupName: 'Jornada',
    configs: getConfigs([
      'jornada-off-delay',
      'audio-jornada-aberta',
      'audio-jornada-fechada'
    ])
  },
  {
    groupName: 'Áudio',
    configs: getConfigs([
      'utiliza-audio',
      'audio-card-ok',
      'audio-card-ruk',
      'audio-card-exp',
      'audio-card-quase-exp'
    ])
  }
]

//                          rpmConstant  number   rpm
//                rpm-via-sw-vel-via-sw  select   rpm
//                         rpm-por-freq  select   rpm
//                         rpm-por-acel  number   rpm
//                       acel-rpm-delay  number   rpm
//                     rpm-por-voltagem  number   rpm

//                        speedConstant  number   speed
//         velocidade-por-gps-min-speed  number   speed
//          velocidade-por-gps-min-time  number   speed

//                  freio-ativa-bateria  select   brake

//                     odometerConstant  number   odo

//               accelerometerThreshold  number   accel
//                  filtro-acelerometro  number   accel

//           trecho-abre-apenas-com-rpm  select   misc
//                 bloqueio-com-timeout  select   misc
//                  poly-change-warning  select   misc
//    pausa-do-gsm-durante-o-dia-em-min  number   misc
//  pausa-do-gsm-durante-a-noite-em-min  number   misc
//   quebra-de-trecho-max-trip-duration  number   misc
//           quebra-de-trecho-tolerance  number   misc
//                       limite-delta-v  number   misc
//              limite-bytes-por-pacote  number   misc
//              mantem-motorista-logado  select   misc
//                         use-sqw-sync  select   misc
//                          use-verbose  select   misc
//                         use-rtcstack  select   misc
//                            bat-limit  number   misc
//                        uso-da-serial  select   misc

//                           valor-an-1  select   sinaisAnalogicos
//                           valor-an-2  select   sinaisAnalogicos
//                           valor-an-3  select   sinaisAnalogicos
//                           valor-an-4  select   sinaisAnalogicos
//                             an1label  select
//                             an1scale  string
//                             an2label  select
//                             an2scale  string
//                             an3label  select
//                             an3scale  string
//                             an4label  select
//                             an4scale  string

//                dg-1-ativa-em-bateria  select   sinaisDigitais
//                dg-2-ativa-em-bateria  select   sinaisDigitais
//                dg-3-ativa-em-bateria  select   sinaisDigitais
//                             dg1label  select
//                             dg2label  select
//                             dg3label  select

//                 validacao-gps-metodo  select   gps
//                 validacao-gps-limite  number   gps
//                    gps-reset-minutes  number   gps
//                   gps-write-distance  number   gps
//                       gps-write-time  number   gps
//                    jornada-off-delay  number   jornada
//                 audio-jornada-aberta  number   jornada
//                audio-jornada-fechada  number   jornada
//                        utiliza-audio  select   audio
//                        audio-card-ok  number   audio
//                       audio-card-ruk  number   audio
//                       audio-card-exp  number   audio
//                 audio-card-quase-exp  number   audio
//                             use-wifi  select   wifi
//                            wifi0ssid  string
//                            wifi0pass  string
//                            wifi1ssid  string
//                            wifi1pass  string
//                            wifi2ssid  string
//                            wifi2pass  string
//                            wifi3ssid  string
//                            wifi3pass  string
//                            wifi4ssid  string
//                            wifi4pass  string
